import Body from "../../../../components/Body";
import SideBar from "../../../../components/SideBar";
import Contents from "../../../../components/Contents";
import Header from "../../../../components/Header";
import { isVisibleScript } from "../../../../utils/displayScript";
import { useHistory, useLocation } from "react-router-dom";
import BoxEmail from "../../components/BoxEmail";
import BoxCheckout from "../../components/BoxCheckout";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import LoadingLogo from "../../../../components/Loading-logo";
import ModalInforVideo from "../../../../components/modal-infor-video";
import AlertCloseBoss from "../../../../components/alert-close-boss";
import { translations } from "../../../../utils/language";
import { FaCode } from "react-icons/fa";
import BoxPageCheckout from "../../components/BoxPageCheckout";
import BoxPersonalizar from "../../components/BoxPersonalizar";
import { ContainerNew } from "../../../dashboard/pages/home-new/styled";
import LazyLoadingThema from "../../../../components/lazy-loading-thema";
import BoxWatermart from "../../components/BoxWatermart";
import { addNotification } from "../../../../empreenderUI/ui/NotificationAlert";

const PERSONALIZAR_ALERT_ID = "personalizar-delay";

const Home = () => {

  const selectedMenu = useLocation();
  const history = useHistory()
  const dispatch = useDispatch();

  const language = useSelector((state) => state.reducerLanguage);
  const [visibleModalInfor, setVisibleModalInfor] = useState(false)

  const controlConfig = useSelector((state) => state.reducerControlConfig);
  const config = useSelector((state) => state.reducerTemplate);

  useEffect(() => {
    dispatch({ type: "SAGA_GET_TEMPLATES", payload: { email_editor: selectedMenu.pathname == "/personalizar/email" } });
  }, []);

  useEffect(() => {
    const message =
      translations["personalizar-alert-delay"]?.[language?.data] ||
      "As mudanças podem levar até 30min para refletir, por favor aguarde";

    return addNotification(message, { id: PERSONALIZAR_ALERT_ID });
  }, [language?.data]);





  const isSave = () => {

    if (
      config.data[0].color_checkout_background_header == controlConfig.color_checkout_background_header &&
      config.data[0].color_checkout_text_header == controlConfig.color_checkout_text_header &&
      config.data[0].color_checkout_background == controlConfig.color_checkout_background &&
      config.data[0].color_checkout_text_title == controlConfig.color_checkout_text_title &&
      config.data[0].color_checkout_background_product == controlConfig.color_checkout_background_product &&
      config.data[0].color_checkout_text_product == controlConfig.color_checkout_text_product &&
      config.data[0].color_button_checkout == controlConfig.color_button_checkout &&
      config.data[0].color_message_button_checkout == controlConfig.color_message_button_checkout &&

      config.data[0].checkout_message_header == controlConfig.checkout_message_header &&
      config.data[0].checkout_message_title == controlConfig.checkout_message_title &&
      config.data[0].checkout_message == controlConfig.checkout_message &&
      config.data[0].checkout_button == controlConfig.checkout_button &&
      config.data[0].checkout_button_link == controlConfig.checkout_button_link &&

      config?.data[0]?.color_email_background == controlConfig.color_email_background &&
      config?.data[0]?.color_title_email == controlConfig.color_title_email &&
      config?.data[0]?.color_button == controlConfig.color_button &&
      config?.data[0]?.color_message_button == controlConfig.color_message_button &&

      config?.data[0]?.subject_email == controlConfig.subject_email &&
      config?.data[0]?.message_email == controlConfig.message_email &&
      config?.data[0]?.message_button == controlConfig.message_button
    ) {
      dispatch({ type: "CONFIG_CONTROL_SAVE_EMAIL_SET", payload: true })
      dispatch({ type: "CONFIG_CONTROL_SAVE_CHECKOUT_SET", payload: true })
      return true
    } else {
      dispatch({ type: "CONFIG_CONTROL_SAVE_EMAIL_SET", payload: false })
      dispatch({ type: "CONFIG_CONTROL_SAVE_CHECKOUT_SET", payload: false })
      return false
    }
  }


  const isPersonalizarRoot = selectedMenu.pathname === "/personalizar";

  return (
    <>
      <ContainerNew>

        <ModalInforVideo visible={visibleModalInfor} setVisibleModal={setVisibleModalInfor} video={`https://www.youtube.com/embed/${language.data == "es" ? "YYt0LQL0zdc" : "U82-BWXPc1c"}`} />

        {isPersonalizarRoot ? (
          <Contents>
            <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
              <BoxPersonalizar onHelpClick={() => setVisibleModalInfor(true)} />
            </div>
          </Contents>
        ) : config.loading == false && config.data?.length > 0 ? (
          <Contents>
            <div style={{ display: "flex", flexDirection: "row", width: "100%", minHeight: "calc(100vh - 240px)" }}>
              <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                {selectedMenu.pathname == "/personalizar/email" && <BoxEmail />}
                {selectedMenu.pathname == "/personalizar/checkout" && <BoxCheckout />}
                {selectedMenu.pathname == "/personalizar/page-checkout" && <BoxPageCheckout />}
                {selectedMenu.pathname == "/personalizar/marca-agua" && <BoxWatermart />}
              </div>
            </div>
          </Contents>
        ) : (
          <LazyLoadingThema />
        )}

        {isVisibleScript(false)}
      </ContainerNew>
    </>
  );
};

export default Home;
